module.exports = __webpack_public_path__ + "name=img/src/assets/emoji/handshake.png?608c01348b17733cbdd5312bc72a4d8b";